import { Logger } from "neo-common";

/**
 * Definitions for payline for all kind of reels.
 * @class PaylinesDefinitions
 */
export class PaylinesDefinitions {
    private static _paylineGroupsDefinitions: Object = {};

    /**
     * Initialize payline definiftion specific for game.
     * @method initializePaylineDefinitions
     * @param paylineGroupId string
     * @return void
     */
    static initializePaylineDefinitions(paylineGroupId: string) {
        var definition: Object = {};

        switch (paylineGroupId) {
            case "5x3":
                definition[1] = [1, 1, 1, 1, 1];
                definition[2] = [0, 0, 0, 0, 0];
                definition[3] = [2, 2, 2, 2, 2];
                definition[4] = [0, 1, 2, 1, 0];
                definition[5] = [2, 1, 0, 1, 2];
                break;
            default:
                if (DEBUG) {
                    this.log("ERROR no definition for " + paylineGroupId);
                }
                return;
        }

        this._paylineGroupsDefinitions[paylineGroupId] = definition;
    }

    /**
     * Get payline by id and group id.
     * @method getPaylineDefinitionsById
     * @param paylineId string
     * @param paylineGroupId string
     * @return void
     */
    static getPaylineDefinitionsById(paylineId: number, paylineGroupId: string): Array<number> {
        if (this._paylineGroupsDefinitions != null) {
            if (this._paylineGroupsDefinitions[paylineGroupId] != null) {
                if (this._paylineGroupsDefinitions[paylineGroupId][paylineId] != null) {
                    return this._paylineGroupsDefinitions[paylineGroupId][paylineId];
                } else {
                    if (DEBUG) {
                        this.log("ERROR no paylineId: " + paylineId + " in " + paylineGroupId);
                    }
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no definition for " + paylineGroupId);
                }
            }
        } else {
            if (DEBUG) {
                this.log("ERROR no paylines definitions");
            }
        }
        return null;
    }

    /**
     * Trace to browser console.
     * @method log
     * @param s string
     * @return void
     */
    private static log(s: string): void {
        if (DEBUG) {
            Logger.debugGroup("PaylineDefinitions", s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/PaylinesDefinitions.ts
 **/